module.exports = __webpack_public_path__ + "static/media/settings-selected.a51742e7.svg";